// extracted by mini-css-extract-plugin
export default {"value-label":"a_co"};